// extracted by mini-css-extract-plugin
export var animationContainer = "_g7-0";
export var asteriskIcon = "_g7-8";
export var conversationLeftSection = "_g7-4";
export var conversationListItem = "_g7-3";
export var conversationMiddleSection = "_g7-5";
export var conversationRightSection = "_g7-6";
export var detailsContent = "_g7-1";
export var listContainer = "_g7-7";
export var modalContent = "_g7-2";